<template>
  <div>
    <MarkdownText :content="text"/>
  </div>
</template>

<script>
import md from '@/content/faq.md'
import MarkdownText from "@/components/MarkdownText.vue"

export default {
  name: 'FAQView',
  components: {
    MarkdownText: MarkdownText
  },
  data() {
    return {
      text: md.toString()
    }
  }
}
</script>
